import { useQuery } from '@tanstack/react-query';
import { getSubClientAssignedPermissions as getSubClientAssignedPermissionsApi } from '../../../services/common/apiCommon';

export function useGetSubClientAssignedPermissions({ roleType, clientId }: { roleType: string; clientId: string }) {
  const currentSelectedClient = sessionStorage.getItem('currentSelectedClient');
  const selectedClientId = currentSelectedClient ? JSON.parse(currentSelectedClient) : null
  const subClientId = selectedClientId?.clientId ?? clientId;

  const {
    isFetching,
    data,
    error
  } = useQuery({
    queryKey: ["subClientAssignedPermissions", subClientId, roleType],
    queryFn: async () => {
      const { data } = await getSubClientAssignedPermissionsApi({ subClientId })
      return data;
    },
    enabled: roleType === "subClient" && !!subClientId,
    staleTime: 0,
    cacheTime: 0
  });

  return { isLoading: isFetching, error, data };
}